module.exports = __webpack_public_path__ + "img/perfil-empatico.712db979.png";